import {MULTIPLE_INVENTORY_TRACKING_ADDON} from 'helpers/constants';

import {loadPriceList} from './priceListActions';
import {loadInventoryItems} from './inventoryItemActions';
import {
  loadInventoryByLocations,
  updateLocationSummary,
} from './inventoryByLocationActions';

export default function reloadInventory(
  dispatch,
  getState,
  {
    doLoadInventoryItems = true,
    doLoadInventoryByLocation = true,
    doLoadInventoryLocationSummary = true,
    useDefaultLocation = false,
    byLocationCallback = null,
  } = {},
) {
  loadPriceList(dispatch, getState);

  const state = getState();
  const {portalSettings} = state.portal;
  const multiLocation = portalSettings[MULTIPLE_INVENTORY_TRACKING_ADDON];
  if (multiLocation && multiLocation.valueAsBool) {
    if (doLoadInventoryByLocation)
      loadInventoryByLocations(dispatch, getState, useDefaultLocation).then(
        () => {
          if (byLocationCallback && typeof byLocationCallback === 'function') {
            byLocationCallback();
          }
        },
      );
    if (doLoadInventoryLocationSummary)
      updateLocationSummary(dispatch, getState);
    if (doLoadInventoryItems) loadInventoryItems(dispatch, getState);
  }
}



// WEBPACK FOOTER //
// ./src/actions/inventoryActions.js